module.exports = __webpack_public_path__ + "a1f30296a1f60ed92f0ded749d078bda.png";